import { useAuth } from "@/contexts/AuthContext";
import { DoctorOverview } from "./DashboardLayout";
import AdminOverview from "./AdminOverview";

export default function DashboardIndex() {
  const { user } = useAuth();
  if (!user || user === false) return null;
  if (user.role === "admin") return <AdminOverview />;
  return <DoctorOverview user={user} />;
}
